import React from 'react';
import { useTranslation } from 'react-i18next';
import { FAQRichPreview } from './styles';

interface FAQPreviewProps {
  activeIndex: number;
  faqKeys: string[];
}

const getIconForBullet = (text: string) => {
  // Mapear ícones baseado no conteúdo do bullet
  if (text.includes('Centralize') || text.includes('histórico') || text.includes('linha do tempo')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    );
  }
  if (text.includes('funil') || text.includes('etapas') || text.includes('conversão')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    );
  }
  if (text.includes('follow-up') || text.includes('alertas') || text.includes('próximas')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    );
  }
  if (text.includes('relatórios') || text.includes('tempo real') || text.includes('decisões')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    );
  }
  if (text.includes('automação') || text.includes('disparo') || text.includes('fluxos')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    );
  }
  if (text.includes('integração') || text.includes('conectar') || text.includes('API')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
      </svg>
    );
  }
  if (text.includes('bot') || text.includes('atendimento') || text.includes('24')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    );
  }
  if (text.includes('segurança') || text.includes('LGPD') || text.includes('criptografia')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
      </svg>
    );
  }
  if (text.includes('import') || text.includes('CSV') || text.includes('dados')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
      </svg>
    );
  }
  if (text.includes('onboarding') || text.includes('rápido') || text.includes('minutos')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    );
  }
  if (text.includes('enterprise') || text.includes('equipe') || text.includes('grande')) {
    return (
      <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    );
  }
  // Ícone padrão
  return (
    <svg className="item-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
};

const FAQPreview: React.FC<FAQPreviewProps> = ({ activeIndex, faqKeys }) => {
  const { t } = useTranslation();

  const getRichPreview = (index: number) => {
    const faqKey = faqKeys[index] || faqKeys[0];
    const preview = t(`faq.items.${faqKey}.preview`, { returnObjects: true }) as {
      category: string;
      title: string;
      lead: string;
      bullets: string[];
      note?: string;
    };

    return {
      kicker: preview.category,
      title: preview.title,
      lead: preview.lead,
      bullets: preview.bullets,
      note: preview.note
    };
  };

  const data = getRichPreview(activeIndex);

  return (
    <FAQRichPreview
      $activeIndex={activeIndex}
      id={`faq-panel-${activeIndex}`}
      role="tabpanel"
      aria-labelledby={`faq-tab-${activeIndex}`}
    >
      <div className="content-wrapper" key={activeIndex}>
        <span className="kicker">{data.kicker}</span>
        <h3 className="title">{data.title}</h3>
        <p className="lead">{data.lead}</p>
        <div className="divider" />
        <div className="list">
          {data.bullets.map((b, i) => (
            <div className="item" key={i}>
              {getIconForBullet(b)}
              <span>{b}</span>
            </div>
          ))}
        </div>
        {data.note && <div className="note">{data.note}</div>}
      </div>
    </FAQRichPreview>
  );
};

export default FAQPreview;
